import React, { useState, useEffect, useRef } from "react";
import footbal from "../../../assets/customerAssets/football.png";
import { Box, Button, ImageListItem, FormHelperText } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import cameraIcon from "../../../assets/customerAssets/icons/camera.svg";
import { supportedImageFileTypes } from "../../../helper/commonFunctions";
import { toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";

const FormProfileComponent = ({ formik, edited, isAdmin }) => {
  const [imgPreview, setImgPreview] = useState(() =>
    edited
      ? formik.values.image
      : formik.values.image
        ? URL.createObjectURL(formik.values.image)
        : null,
  );
  const imageInputRef = useRef(null);
  const [clicked, setClicked] = useState(false);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      toast.error("Please select a file");
      return;
    }
    const fileType = file.type.split("/")[1];
    const fileExt = file.name.split(".").pop().toLowerCase();

    if (
      supportedImageFileTypes.includes(file.type) === false &&
      supportedImageFileTypes.includes(fileExt) === false
    ) {
      toast.error("Please select a valid image file");
      return;
    }

    setImgPreview(URL.createObjectURL(file));
    formik.setFieldValue("image", file);
    formik.setFieldTouched("image", true);
    setClicked(true);
  };


  return (
    <>
      <Box className="formProfile">
        <input
          type="file"
          name="image"
          onChange={handleChange}
          onBlur={formik.handleBlur}
          style={{ display: "none" }}
          ref={imageInputRef}
        />
        <Box className="option-outter" sx={{ padding: "0" }}>
          <div className="option-inner">
            <img
              src={imgPreview ? imgPreview : footbal}
              alt="football"
              className="img_fluid"
              style={imgPreview ? { objectFit: "cover" } : { opacity: "24%" }}
            />
          </div>
        </Box>

        <Button
          // className="icon-wrapper "
          className={`icon-wrapper ${!isAdmin ? "form_component_hide" : ""}`}
          sx={!isAdmin ? { display: "none !important" } : {}}
          onClick={() => imageInputRef.current.click()}
        >
          <div className="img-div">
            <img src={cameraIcon} alt="camera" className="img_fluid" />
          </div>
        </Button>
      </Box>
      {(clicked && !formik.values.image) ||
      (formik.submitCount > 0 && !formik.values.image) ? (
        <FormHelperText sx={{ color: "red" }}>
          {`Tournament logo is required.`}
        </FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};

export default FormProfileComponent;
